export {default as VtxModalList} from './VtxModalList';
export {default} from './VtxModalList';